import React from 'react';
import { Box, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


const SelectCommodite = ({commodites,setCommodites}) => {

 
  const handleCheckboxChange = (id) => (event) => {
    event.preventDefault()
    setCommodites((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, checked: event.target.checked,number:1 } : item
      )
    );
  };

  const handleIncrement = (id) => () => {
    setCommodites((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, number: item.number + 1 } : item
      )
    );
  };

  const handleDecrement = (id) => () => {
    setCommodites((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, number: Math.max(item.number - 1, 1) } : item
      )
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {commodites.map((item) => (
        <Box
          key={item.id}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: 0,
            margin: 0,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={item.checked}
                onChange={handleCheckboxChange(item.id)}
                sx={{ padding: 0, margin: 0 }}
              />
            }
            label={item.label}
            sx={{ margin: 0 }}
          />
          {item.checked && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <IconButton onClick={handleDecrement(item.id)}>
                <RemoveIcon />
              </IconButton>
              <span>{item.number}</span>
              <IconButton onClick={handleIncrement(item.id)}>
                <AddIcon />
              </IconButton>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default SelectCommodite;
